import { createSlice } from "@reduxjs/toolkit";


const initialState: any = {
    incomeAndExpenses: [],
    loading: false,
    error: null,
  };
const incomeAndExpensesSlice = createSlice({
    name: "incomeAndExpenses",
    initialState,
    reducers: {
        incomeAndExpensesRequest(state) {
        state.loading = true;
        state.error = null;
      },
      incomeAndExpensesSuccess(state, action) {
        state.loading = false;
        state.incomeAndExpenses = action.payload;
      },
      incomeAndExpensesAddSuccess(state, action) {
        state.loading = false;
        state.incomeAndExpenses.push(action.payload);
      },
      incomeAndExpensesEditSuccess(state, action) {
        state.loading = false;
        state.incomeAndExpenses = state.incomeAndExpenses.map((incomeAndExpenses: { id: any; }) =>
          incomeAndExpenses.id === action.payload.id ? action.payload : incomeAndExpenses
        );
      },
      incomeAndExpensesDeleteSuccess(state, action) {
        state.loading = false;
        state.incomeAndExpenses = state.incomeAndExpenses.filter((incomeAndExpenses: { id: any; }) => incomeAndExpenses.id !== action.payload);
      },
      incomeAndExpensesError(state, action) {
        state.loading = false;
        state.error = action.payload;
      },
    },
  });

  export const {
      incomeAndExpensesRequest,
      incomeAndExpensesSuccess,
      incomeAndExpensesAddSuccess,
      incomeAndExpensesEditSuccess,
      incomeAndExpensesDeleteSuccess,
      incomeAndExpensesError,
  } = incomeAndExpensesSlice.actions;

export default incomeAndExpensesSlice.reducer;
  